import { useLocation } from "react-router-dom";
import { HomeLayout } from "../../layouts";
import { getModuleConfig } from "../../config/modulePageConfig";
import ModuleReportContent from "../Home/ModuleReportContent";

const ModulePage = () => {
  const path = useLocation().pathname;
  const { title, navLabel } = getModuleConfig(path);

  return (
    <HomeLayout>
      <ModuleReportContent title={title} navLabel={navLabel} />
    </HomeLayout>
  );
};

export default ModulePage;
